/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import DateTime from 'ContentComponents/cmv2/fields/DateTime';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { DATE } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

export default class _class extends Component {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(ToolFormControl, {
      label: I18n.text(i18nKey(`defaultLabels.${DATE}`)),
      children: /*#__PURE__*/_jsx(SidebarInput, {
        inputComponent: DateTime,
        onFieldChange: this.onDefaultChange,
        type: field.type,
        value: field[DEFAULT],
        readOnly: readOnly
      })
    });
  }

}
_class.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};